


<template>
  <div>

    <el-tabs v-model="activeNames" @tab-click="handleClicks" type="border-card">

        <el-tab-pane label="整体" name="整体" v-if="getSubjectPermissions === 'S'">
            <firstComponents  v-if="activeName === '整体'" type="新增率图表" ref="firstChart" :translate="translate"></firstComponents>
        </el-tab-pane>

        <el-tab-pane label="老师" name="老师" v-if="getSubjectPermissions === 'S'">
            <FistClassTableTeacherStart v-if="activeName === '老师'"  type="新增率图表" ref="FistClassTableTeacherStart" ></FistClassTableTeacherStart>
        </el-tab-pane>

        <el-tab-pane label="学生" name="学生" v-if="getSubjectPermissions === 'S'">
           <FistClassTableStudentStart  v-if="activeName === '学生'"  type="新增率图表" ref="FistClassTableStudentStart" ></FistClassTableStudentStart>
        </el-tab-pane>

        <el-tab-pane label="学科组" name="学科组" v-if="getSubjectPermissions === 'Y' || getSubjectPermissions === 'S'">
           <FistClassTableStudentStartcopycopycopycopy  v-if="activeName === '学科组'" toAdd="学科组" type="新增率图表" ref="FistClassTableStudentStart" ></FistClassTableStudentStartcopycopycopycopy>
        </el-tab-pane>

    </el-tabs>



  </div>
</template>



<script>

import firstComponents from './first.vue';
import secondComponents from './second.vue';

import FistClassTableTeacherStart from './FistClassTable/FistClassTableTeacherStart.vue';
import FistClassTableTeacherEnd from './FistClassTable/FistClassTableTeacherEnd.vue';
import FistClassTableStudentStart from './FistClassTable/FistClassTableStudentStart.vue';
import FistClassTableStudentEnd from './FistClassTable/FistClassTableStudentEnd.vue';
import FistClassTableStudentStartcopycopycopycopy from './FistClassTable/FistClassTableStudentStartcopycopycopycopy.vue';

export default {
  name: 'LncreaseRateEchart',
  components: {
    firstComponents,
    FistClassTableStudentStartcopycopycopycopy,
    secondComponents,
    FistClassTableTeacherStart,
    FistClassTableTeacherEnd,
    FistClassTableStudentStart,
    FistClassTableStudentEnd,
  },
  data() {
    return {
        activeName: '整体',
        activeNames: '整体',
        translate: null,


        TeacheractiveName : 'first', // 老师的activeName
        StudentactiveName : 'first', // 老师的activeName

        getSubjectPermissions: '',
    }
  },

  computed: {
   
  },

  mounted() {
     let getSubjectPermissions = sessionStorage.getItem('getSubjectPermissions')
    this.getSubjectPermissions = getSubjectPermissions

    if(this.getSubjectPermissions === 'Y'){
        this.activeName = '学科组'
        this.activeNames = '学科组'
     }
  },

  methods: {

    handleClick(e){

    },


    handleClickTeachera(e){
      console.log(e);
       
      if (e.name === 'second') {
          this.$nextTick(() => {
            this.$refs.FistClassTableTeacherEnd && this.$refs.FistClassTableTeacherEnd.initCharts && this.$refs.FistClassTableTeacherEnd.initCharts();
          });
      }
      
    },

    handleClickStudent(e){
      

    },

    handleClicks(e){
        this.activeName = e.name;
        this.translate = e;

        if (e.name === '整体') {
            this.$nextTick(() => {
              this.$refs.firstChart && this.$refs.firstChart.initCharts && this.$refs.firstChart.initCharts();
            });
        }
        if (e.name === '老师') {
            this.$nextTick(() => {
              this.$refs.FistClassTableTeacherStart && this.$refs.FistClassTableTeacherStart.handleGetDateList && this.$refs.FistClassTableTeacherStart.handleGetDateList();
            });
        }
        if (e.name === '学生') {
            this.$nextTick(() => {
              this.$refs.FistClassTableStudentStart && this.$refs.FistClassTableStudentStart.handleGetDateList && this.$refs.FistClassTableStudentStart.handleGetDateList();
            });
        }
        if (e.name === '学科组') {
            this.$nextTick(() => {
              this.$refs.FistClassTableStudentStart && this.$refs.FistClassTableStudentStart.handleGetDateList && this.$refs.FistClassTableStudentStart.handleGetDateList();
            });
        }
    },

  },


}


</script>




<style  scoped>


</style>




// WEBPACK FOOTER //
// src/CourseTypeAnalysisEchart/LncreaseRateEchart.vue